import React, { useState } from 'react';
import css from './SectionSubscribeEmail.module.css';
import { emailFormatValid } from '../../../../util/validators';
import { createContactInBrevo } from '../../../../util/api';
import { useIntl } from 'react-intl';
import { IconSpinner } from '../../../../components';

function SectionSubscribeEmail(props) {
  const { section } = props;
  const { title, description } = section || {};
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const intl = useIntl();

  const handleSubscribe = async () => {
    const errorMessage = intl.formatMessage({ id: 'SectionSubscribeEmail.errorMessage' });
    const isValidEmail = emailFormatValid(errorMessage)(email);

    if (isValidEmail) {
      setError(isValidEmail);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await createContactInBrevo({ email });

      if (!response.success) {
        throw new Error(intl.formatMessage({ id: 'SectionSubscribeEmail.errorMessage' }));
      }

      alert(intl.formatMessage({ id: 'SectionSubscribeEmail.successMessage' }));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setEmail('');
    }
  };

  return (
    <div className={css.root}>
      <h2 className={css.title}>{title.content}</h2>
      <h4 className={css.description}>{description.content}</h4>
      <div className={css.formContainer}>
        <input
          type="email"
          placeholder={intl.formatMessage({ id: 'SectionSubscribeEmail.placeholder' })}
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        {loading ? (
          <IconSpinner />
        ) : (
          <button onClick={handleSubscribe} disabled={loading}>
            {intl.formatMessage({ id: 'SectionSubscribeEmail.subscribe' })}
          </button>
        )}
      </div>
      {error && <p className={css.error}>{error}</p>}
    </div>
  );
}

export default SectionSubscribeEmail;
